import {theme} from '@logistics-frontend/blocks/lpc/theme'
import {css} from '@logistics-frontend/blocks/theme/css'

const desktopWidth = 640
const mobileHeight = 220

export const classes = {
  container: css`
    position: relative;
    height: calc(100vh - 64px);

    ${theme.breakpoints.down('sm')} {
      padding-top: ${mobileHeight}px;
    }
  `,
  form: css`
    padding: ${theme.spacing(3, 3, 0, 3)};
    background: #fff;
    width: ${desktopWidth}px;
    height: 100%;
    position: relative;
    z-index: 5;
    box-shadow: 0 1px 0 rgba(195, 194, 190, 0.4) inset;
    overflow-y: auto;

    ${theme.breakpoints.down('sm')} {
      box-shadow: none;
      border-top-left-radius: 24px;
      border-top-right-radius: 24px;
      padding: ${theme.spacing(1, 1.5, 0, 1.5)};
      overflow: visible;
      width: auto;
    }
  `,
  map: css`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: ${desktopWidth}px;
    z-index: 3;

    ${theme.breakpoints.down('sm')} {
      left: 0;
      bottom: auto;
      height: calc(${mobileHeight}px + 25px);
    }
  `,
  formWrap: css`
    margin-top: ${theme.spacing(3.75)}px;

    ${theme.breakpoints.down('sm')} {
      margin-top: ${theme.spacing(1.5)}px;
    }
  `,
}

export const tabsClasses = {
  root: css`
    ${theme.breakpoints.down('sm')} {
      margin: ${theme.spacing(0, -1.5)};
    }
  `,
  flexContainer: css`
    ${theme.breakpoints.down('sm')} {
      border-bottom: 1px solid rgba(195, 194, 190, 0.4);
      justify-content: space-around;
    }
  `,
}
